module.exports = __webpack_public_path__ + "static/media/startseite_zu_ohne.1f0a67f3.jpg";